module.exports = __webpack_public_path__ + "static/media/Cart.6139f671.svg";